/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var CheckA2Icon24Regular = forwardRef('CheckA2Icon24Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M18.445 6.718a.75.75 0 1 0-1.06-1.06L7.134 15.905a1.631 1.631 0 0 1-2.306 0l-3.493-3.493a.75.75 0 1 0-1.061 1.06l3.493 3.494a3.131 3.131 0 0 0 4.428 0l10.249-10.25Z" }),
        React.createElement("path", { d: "M23.678 6.718a.75.75 0 1 0-1.06-1.06l-10.911 10.91a.75.75 0 1 0 1.06 1.06L23.68 6.719Z" })));
});
